// Copy for the stand-alone pay-link page (/pay/:orderNumber). The page is
// shown in the language the order was taken in.

var payText = {
  en: {
    loading: 'Loading your order…',
    loadError: 'We couldn’t load this order',
    orderLabel: 'Order',
    complete: 'Complete your order',
    thanks: 'Thank you — you’re all set',
    qty: 'Qty',
    subtotal: 'Subtotal',
    shipping: 'Shipping',
    tax: 'Tax',
    discount: 'Discount',
    total: 'Total',
    preorder: 'PRE-ORDER',
    presaleNote: 'Titles marked PRE-ORDER are being indexed right now — the download link for each one is emailed to you automatically the moment it’s finished. Everything else is available immediately.',
    received: 'Payment received',
    receiptOnWay: 'A receipt is on its way to your inbox',
    popupHint: 'If the PayPal window doesn’t open, allow pop-ups for this site and try again.',
    paypalMissing: 'PayPal is not configured.',
    cash: 'Paying in cash',
    bank: 'Paying by bank transfer',
    offlineNote: 'Isaías will confirm your payment, and your receipt (plus any download links) arrives by email right after.',
    shipWhere: 'Where should we ship it?',
    shipWhy: 'Your order includes something physical, so we need an address to add shipping before you pay.',
    addrErr: 'Please fill in street, city and ZIP code',
    savingAddr: 'Pricing shipping…',
    saveAddr: 'Save address & show my total',
    f_first_name: 'First name', f_last_name: 'Last name', f_street_address: 'Street address',
    f_extended_address: 'Apt / unit (optional)', f_locality: 'City', f_region: 'State',
    f_postal_code: 'ZIP code', f_phone: 'Phone (optional)'
  },
  es: {
    loading: 'Cargando tu pedido…',
    loadError: 'No pudimos cargar este pedido',
    orderLabel: 'Pedido',
    complete: 'Completa tu pedido',
    thanks: 'Gracias — todo listo',
    qty: 'Cant.',
    subtotal: 'Subtotal',
    shipping: 'Envío',
    tax: 'Impuestos',
    discount: 'Descuento',
    total: 'Total',
    preorder: 'PREVENTA',
    presaleNote: 'Los títulos marcados como PREVENTA se están indexando ahora — el enlace de descarga de cada uno te llega por correo automáticamente en cuanto esté listo. Todo lo demás está disponible de inmediato.',
    received: 'Pago recibido',
    receiptOnWay: 'Tu recibo va en camino a tu correo',
    popupHint: 'Si la ventana de PayPal no abre, permite las ventanas emergentes en este sitio e inténtalo de nuevo.',
    paypalMissing: 'PayPal no está configurado.',
    cash: 'Pago en efectivo',
    bank: 'Pago por transferencia bancaria',
    offlineNote: 'Isaías confirmará tu pago y tu recibo (con los enlaces de descarga) llega por correo enseguida.',
    shipWhere: '¿A dónde lo enviamos?',
    shipWhy: 'Tu pedido incluye algo físico, así que necesitamos una dirección para calcular el envío antes de pagar.',
    addrErr: 'Completa calle, ciudad y código postal',
    savingAddr: 'Calculando envío…',
    saveAddr: 'Guardar dirección y ver mi total',
    f_first_name: 'Nombre', f_last_name: 'Apellido', f_street_address: 'Calle y número',
    f_extended_address: 'Depto. / interior (opcional)', f_locality: 'Ciudad', f_region: 'Estado',
    f_postal_code: 'Código postal', f_phone: 'Teléfono (opcional)'
  },
  ja: {
    loading: 'ご注文を読み込んでいます…',
    loadError: 'この注文を読み込めませんでした',
    orderLabel: '注文',
    complete: 'ご注文の手続き',
    thanks: 'ありがとうございます — 手続きが完了しました',
    qty: '数量',
    subtotal: '小計',
    shipping: '送料',
    tax: '税',
    discount: '割引',
    total: '合計',
    preorder: '予約',
    presaleNote: '「予約」と表示されたタイトルは現在インデックス作成中です。完成した瞬間に、各タイトルのダウンロードリンクが自動でメール送信されます。その他の商品はすぐにご利用いただけます。',
    received: '決済を受け付けました',
    receiptOnWay: '領収書をメールでお送りしています',
    popupHint: 'PayPal のウィンドウが開かない場合は、このサイトのポップアップを許可して再度お試しください。',
    paypalMissing: 'PayPal が設定されていません。',
    cash: '現金でのお支払い',
    bank: '銀行振込でのお支払い',
    offlineNote: 'Isaías が入金を確認後、領収書（およびダウンロードリンク）をすぐにメールでお送りします。',
    shipWhere: 'お届け先を教えてください',
    shipWhy: '配送が必要な商品が含まれているため、お支払い前に送料計算のための住所が必要です。',
    addrErr: '番地・市区町村・郵便番号を入力してください',
    savingAddr: '送料を計算中…',
    saveAddr: '住所を保存して合計を表示',
    f_first_name: '名', f_last_name: '姓', f_street_address: '番地・町名',
    f_extended_address: '建物名・部屋番号（任意）', f_locality: '市区町村', f_region: '都道府県',
    f_postal_code: '郵便番号', f_phone: '電話番号（任意）'
  },
  de: {
    loading: 'Deine Bestellung wird geladen…',
    loadError: 'Diese Bestellung konnte nicht geladen werden',
    orderLabel: 'Bestellung',
    complete: 'Bestellung abschließen',
    thanks: 'Danke — alles erledigt',
    qty: 'Menge',
    subtotal: 'Zwischensumme',
    shipping: 'Versand',
    tax: 'Steuer',
    discount: 'Rabatt',
    total: 'Gesamt',
    preorder: 'VORBESTELLUNG',
    presaleNote: 'Titel mit VORBESTELLUNG werden gerade indexiert — den Download-Link erhältst du automatisch per E-Mail, sobald der jeweilige Titel fertig ist. Alles andere ist sofort verfügbar.',
    received: 'Zahlung erhalten',
    receiptOnWay: 'Die Rechnung ist auf dem Weg in dein Postfach',
    popupHint: 'Öffnet sich das PayPal-Fenster nicht, erlaube Pop-ups für diese Seite und versuche es erneut.',
    paypalMissing: 'PayPal ist nicht konfiguriert.',
    cash: 'Zahlung in bar',
    bank: 'Zahlung per Banküberweisung',
    offlineNote: 'Isaías bestätigt deine Zahlung, danach kommt die Rechnung (samt Download-Links) direkt per E-Mail.',
    shipWhere: 'Wohin sollen wir liefern?',
    shipWhy: 'Deine Bestellung enthält einen physischen Artikel — wir brauchen eine Adresse, um den Versand vor der Zahlung zu berechnen.',
    addrErr: 'Bitte Straße, Stadt und PLZ ausfüllen',
    savingAddr: 'Versand wird berechnet…',
    saveAddr: 'Adresse speichern & Gesamt anzeigen',
    f_first_name: 'Vorname', f_last_name: 'Nachname', f_street_address: 'Straße und Nr.',
    f_extended_address: 'Wohnung / Zusatz (optional)', f_locality: 'Stadt', f_region: 'Bundesland',
    f_postal_code: 'PLZ', f_phone: 'Telefon (optional)'
  },
  fr: {
    loading: 'Chargement de votre commande…',
    loadError: 'Impossible de charger cette commande',
    orderLabel: 'Commande',
    complete: 'Finaliser votre commande',
    thanks: 'Merci — tout est réglé',
    qty: 'Qté',
    subtotal: 'Sous-total',
    shipping: 'Livraison',
    tax: 'Taxes',
    discount: 'Remise',
    total: 'Total',
    preorder: 'PRÉCOMMANDE',
    presaleNote: 'Les titres marqués PRÉCOMMANDE sont en cours d’indexation — le lien de téléchargement vous est envoyé automatiquement par e-mail dès qu’un titre est prêt. Tout le reste est disponible immédiatement.',
    received: 'Paiement reçu',
    receiptOnWay: 'Votre reçu arrive dans votre boîte mail',
    popupHint: 'Si la fenêtre PayPal ne s’ouvre pas, autorisez les pop-ups pour ce site et réessayez.',
    paypalMissing: 'PayPal n’est pas configuré.',
    cash: 'Paiement en espèces',
    bank: 'Paiement par virement bancaire',
    offlineNote: 'Isaías confirmera votre paiement, puis votre reçu (et les liens de téléchargement) arrive par e-mail.',
    shipWhere: 'Où devons-nous livrer ?',
    shipWhy: 'Votre commande contient un article physique : il nous faut une adresse pour calculer la livraison avant le paiement.',
    addrErr: 'Merci d’indiquer la rue, la ville et le code postal',
    savingAddr: 'Calcul de la livraison…',
    saveAddr: 'Enregistrer l’adresse et voir mon total',
    f_first_name: 'Prénom', f_last_name: 'Nom', f_street_address: 'Adresse',
    f_extended_address: 'Appartement (facultatif)', f_locality: 'Ville', f_region: 'Région',
    f_postal_code: 'Code postal', f_phone: 'Téléphone (facultatif)'
  },
  it: {
    loading: 'Caricamento del tuo ordine…',
    loadError: 'Non riusciamo a caricare questo ordine',
    orderLabel: 'Ordine',
    complete: 'Completa il tuo ordine',
    thanks: 'Grazie — è tutto pronto',
    qty: 'Qtà',
    subtotal: 'Subtotale',
    shipping: 'Spedizione',
    tax: 'Tasse',
    discount: 'Sconto',
    total: 'Totale',
    preorder: 'PREORDINE',
    presaleNote: 'I titoli indicati come PREORDINE sono in fase di indicizzazione — il link per il download ti arriva automaticamente via email nel momento in cui è pronto. Tutto il resto è disponibile subito.',
    received: 'Pagamento ricevuto',
    receiptOnWay: 'La ricevuta sta arrivando nella tua casella email',
    popupHint: 'Se la finestra PayPal non si apre, consenti i pop-up per questo sito e riprova.',
    paypalMissing: 'PayPal non è configurato.',
    cash: 'Pagamento in contanti',
    bank: 'Pagamento con bonifico bancario',
    offlineNote: 'Isaías confermerà il pagamento e subito dopo riceverai la ricevuta (con eventuali link di download) via email.',
    shipWhere: 'Dove spediamo?',
    shipWhy: 'Il tuo ordine contiene un articolo fisico: ci serve un indirizzo per calcolare la spedizione prima del pagamento.',
    addrErr: 'Inserisci via, città e CAP',
    savingAddr: 'Calcolo della spedizione…',
    saveAddr: 'Salva indirizzo e mostra il totale',
    f_first_name: 'Nome', f_last_name: 'Cognome', f_street_address: 'Via e numero',
    f_extended_address: 'Interno (opzionale)', f_locality: 'Città', f_region: 'Provincia',
    f_postal_code: 'CAP', f_phone: 'Telefono (opzionale)'
  },
  uk: {
    loading: 'Завантажуємо ваше замовлення…',
    loadError: 'Не вдалося завантажити це замовлення',
    orderLabel: 'Замовлення',
    complete: 'Завершіть замовлення',
    thanks: 'Дякуємо — усе готово',
    qty: 'К-ть',
    subtotal: 'Проміжна сума',
    shipping: 'Доставка',
    tax: 'Податок',
    discount: 'Знижка',
    total: 'Разом',
    preorder: 'ПРЕДЗАМОВЛЕННЯ',
    presaleNote: 'Позиції з позначкою ПРЕДЗАМОВЛЕННЯ зараз індексуються — посилання на завантаження надійде вам на email автоматично, щойно кожна з них буде готова. Усе інше доступне відразу.',
    received: 'Оплату отримано',
    receiptOnWay: 'Квитанція вже надсилається на вашу пошту',
    popupHint: 'Якщо вікно PayPal не відкривається, дозвольте спливаючі вікна для цього сайту та спробуйте ще раз.',
    paypalMissing: 'PayPal не налаштовано.',
    cash: 'Оплата готівкою',
    bank: 'Оплата банківським переказом',
    offlineNote: 'Isaías підтвердить оплату, і відразу після цього ви отримаєте квитанцію (разом із посиланнями на завантаження) на email.',
    shipWhere: 'Куди надіслати?',
    shipWhy: 'Ваше замовлення містить фізичний товар, тому нам потрібна адреса, щоб розрахувати доставку до оплати.',
    addrErr: 'Вкажіть вулицю, місто та поштовий індекс',
    savingAddr: 'Розраховуємо доставку…',
    saveAddr: 'Зберегти адресу й показати суму',
    f_first_name: 'Ім’я', f_last_name: 'Прізвище', f_street_address: 'Вулиця, будинок',
    f_extended_address: 'Квартира (необов’язково)', f_locality: 'Місто', f_region: 'Область',
    f_postal_code: 'Індекс', f_phone: 'Телефон (необов’язково)'
  }
};

export default payText;
